import React from 'react';
import { LinkItem } from '@atlaskit/menu';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { useBoardSettingsUrl } from '@atlassian/jira-software-board-settings-rapidboard-config-common/src/controllers/use-board-settings-url/index.tsx';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import messages from './messages.tsx';

export type ConfigureBoardMenuItemProps = {};

// TODO Add an app prefix to separate apps
const storageProvider = createLocalStorageProvider('', false);

/**
 * Reads the CMP selected tab from localStorage. This is set by the legacy FE on:
 *
 * `jira-components/jira-legacy-frontend/greenhopper-frontend/src/main/resources/jira-agile-module/includes/js/rapid/state/RapidBoardState.js#389,408,414,431`
 *
 * In case there is an error reading/parsing the value of it its missing we will
 * use the 'default' tab.
 */
export function readSelectedConfigTab(): string {
	const defaultValue = 'default';
	let value;
	try {
		if (fg('jfp-vulcan-browser-storage-migration')) {
			value = storageProvider.get('selectedConfigTab');
		} else {
			value = localStorage.getItem('selectedConfigTab');
		}
		return value ? JSON.parse(value) : defaultValue;
	} catch (err) {
		return defaultValue;
	}
}

function useBoardSettingsUrlFn() {
	const settingsUrl = useBoardSettingsUrl();
	const view = readSelectedConfigTab();
	return `${settingsUrl}/${view === 'default' ? 'filter' : view}`;
}

const ConfigureBoardMenuItem = () => {
	const { formatMessage } = useIntl();
	const configureBoardUrl = useBoardSettingsUrlFn();

	return (
		<LinkItem
			href={configureBoardUrl}
			data-testid="software-board.header.menu.configure-board.custom-item"
		>
			{formatMessage(messages.displayText)}
		</LinkItem>
	);
};

export default ConfigureBoardMenuItem;
